import React from 'react';
import { Mail, Phone, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Contact.css';

const Contact = () => (
    <section id="contact" className="contact-teaser">
        <div className="container">
            <motion.div
                className="cta-card"
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, ease: [0.4, 0, 0.2, 1] }}
            >
                {/* subtle top-edge highlight */}
                <div className="cta-card-glow" aria-hidden="true" />

                <div className="cta-inner">
                    <div className="cta-left">
                        <span className="cta-eyebrow">Have a project in mind?</span>
                        <h2 className="cta-heading">
                            Let's turn your idea into a <br />
                            <span className="text-gradient">digital solution that works.</span>
                        </h2>
                        <p className="cta-sub">
                            Tell us about your project. We&rsquo;ll have a first response back within 24 hours.
                        </p>
                    </div>

                    <div className="cta-right">
                        <Link to="/contact" className="btn-primary cta-btn">
                            Start Your Project <ArrowRight size={16} />
                        </Link>
                        <div className="cta-contact-links">
                            <a href="mailto:info@kodebuildtech.com" className="cta-contact-link">
                                <Mail size={13} />
                                info@kodebuildtech.com
                            </a>
                            <span className="cta-sep" aria-hidden="true">·</span>
                            <a href="tel:+263777305046" className="cta-contact-link">
                                <Phone size={13} />
                                +263 77 730 5046
                            </a>
                        </div>
                    </div>
                </div>
            </motion.div>
        </div>
    </section>
);

export default Contact;
